export const MY_VARO = 'myvaro';
export const EXTERNAL_ACCOUNTS = 'external-accounts';
